import { Navbar } from "@/components/admin-panel/navbar";

interface ContentLayoutProps {
  children: React.ReactNode;
}

export function ContentLayout({ children }: ContentLayoutProps) {
  return (
    <div>
      <Navbar />

      <div
        id="content-layout"
        className="container pt-8 pb-8 px-4 sm:px-8 flex justify-center items-center mx-auto"
      >
        {children}
      </div>
    </div>
  );
}
